import { useLanguage } from '../../contexts/language';

import { Button } from '../button';

import styles from './style.module.css';

// The action row under every step of a stepped form: a square back button
// beside the main button, and, for a step that can be skipped, a Skip link
// under the main button, aligned right (the blueprint's rule).
//
// The main button submits the step's form; the parent form decides what
// submitting means. backDisabled holds the back button while the step's own
// back action runs, as signing out from the first onboarding step does.
export function StepActions({ backLabel, onBack, backDisabled, submitLabel, busy, skipLabel, onSkip }) {
  const { text } = useLanguage();

  let label = text.previousStep;

  if (typeof backLabel === 'string') {
    label = backLabel;
  }

  let skip = null;

  if (typeof onSkip === 'function') {
    skip = (
      <div className={ styles.skipRow }>
        <button className={ styles.skip } type='button' disabled={ busy } onClick={ onSkip }>{ skipLabel }</button>
      </div>
    );
  }

  return (
    <div className={ styles.actions }>
      <div className={ styles.row }>
        <button className={ styles.back } type='button' aria-label={ label } disabled={ backDisabled } onClick={ onBack }>
          <span className={ styles.arrow }></span>
        </button>

        <Button type='submit' disabled={ busy }>{ submitLabel }</Button>
      </div>

      { skip }
    </div>
  );
}
